export const COLOR_INDEX = {
  BACKGROUND_COLOR_INDEX: 0,
  TEXT_COLOR_INDEX: 1,
};

export const DATA_INDEX = {
  VALUE: 0,
};
